import React from 'react';

export const HumanaProcessingReadMe: React.FC = () => {
  return (
    <div>
      <h3>Standard Procedure</h3>
      <p>
        Humana processing is generally done by 10 pm on Saturday, I think. You should check on the status of it as early as possible on Saturday morning, to ensure their networks were successfully uploaded and projects have begun processing, then once more after things have finished processing, including reports. To check on those things follow these steps.
      </p>
      <ol>
        <li>Run the query {'{Link to come}'} on Saturday morning, after updating <code>@dateCreated</code> to the Saturday of the run.</li>
        <li>You should see a huge chunk (~200) of network versions created early Saturday morning in UTC, and the very first one (around number 200 in the list) will be called <code>Full Network</code>. If those show up in the query results as activated, things are likely chugging along just fine. If not, you have a QESI problem. God save you.</li>
        <img id="humana-processing-readme-1" role="img" src={`${window.customUIBaseUrl}/images/weekendRunMonitoringReadme/humana-processing-readme-1.png`} alt="Humana Processing Image 1" className="d-block my-2" />
        <li>The results of the second query should show some running 1002 jobs the first time you run it Saturday, but in the end, you should see about 300 completed report jobs and nearly 11,000 adequacy county jobs. If you see no 1001 jobs when you query first thing on Saturday, you may have a QESI problem.</li>
        <img id="humana-processing-readme-2" role="img" src={`${window.customUIBaseUrl}/images/weekendRunMonitoringReadme/humana-processing-readme-2.png`} alt="Humana Processing Image 2" className="d-block my-2" />
        <li>Check the results on Saturday night.  If all is done, you are done!
          <ul>
            <li>
              If not done, check again Sunday.
            </li>
          </ul>
        </li>
        <li>I have seen a single job fail for Humana in the past, and I simply requeued it via API to make things go through.</li>
      </ol>
      <h4>If Projects Have Not Been Queued or Networks Not Activated</h4>
      <ol>
        <li>It’s very likely an issue during the process of QESI uploading the provider data to QES. I prepared {'{Link to come}'} guide for that happening. <strong>I BELIEVE THIS IS ONLY SAFE TO DO IF NO RECORDS HAVE BEEN UPLOADED TO QES PROVIDER TABLES, SO CHECK THAT FIRST.</strong></li>
        <li>Monitor the weekend run as usual, but also post in the <code>humana_refresh</code> slack channel what you had to do, and that there may be a delay in delivery, but you will monitor it throughout the day and provide updates. We must deliver to Humana by ~11 am on Sunday – meaning all reports must be created for their retrieval through QESI.</li>
      </ol>
      <h4>To Requeue Reports</h4>
      <ol>
        <li>Find the job in the jobs table in the database</li>
        <ul>
          <li>
            <pre>
              <code>
                SELECT *<br />
                FROM job j<br />
                WHERE j.JobId = 65010711 or j.JobId = 65011924
              </code>
            </pre>
          </li>
        </ul>
        <li>Set the start and finish dates to NULL so the job goes back into queued in the Job Listing</li>
        <li>Go to the UI and Hit Requeue</li>
        <img id="humana-processing-readme-3" role="img" src={`${window.customUIBaseUrl}/images/weekendRunMonitoringReadme/humana-processing-readme-3.png`} alt="Humana Processing Image 3" className="d-block my-2" />
        <li>Find and update the JobQueueId</li>
        <ul>
          <li>
            <pre>
              <code>
                SELECT *<br />
                FROM dbo.JobQueueMap jqm<br />
                JOIN dbo.JobQueue jq ON jq.Id = jqm.JobQueueId<br />
                WHERE jqm.ProjectId = 24470 OR (jqm.ClientId = 143 AND jqm.JobTypeId = 1009 AND jqm.ProjectId IS NULL)
              </code>
            </pre>
          </li>
          <li>
            <pre>
              <code>
                --INSERT INTO dbo.JobQueueMap(ClientId, JobTypeId, JobQueueId, ProjectId)<br />
                --VALUES(143, -- ClientId – int<br />
                --1009, -- JobTypeId – int<br />
                --17, -- JobQueueId – int<br />
                --24470 -- ProjectId - int)
              </code>
            </pre>
          </li>
        </ul>
      </ol>
    </div>
  );
};